import React from 'react';
import { Box, Text, HStack, Button, Link, Image } from '@chakra-ui/react';

const Payment = () => {
  return (
    <Box
      w="full"
      h={['100vh', '75vh']}
      alignItems="flex-start"
      bg={['#F5F8FF', '']}
      justifyContent="center"
      display="flex"
      py='.5rem'
    >
      <Box
        w={['90%',"75%"]}
        p={['1.75rem', '2rem', '2rem', '3rem']}
        display="flex"
        flexDirection={['column', 'row']}
        alignItems="center"
        justifyContent="space-around"
        bg="#FCFCFC"
        borderRadius="20px"
      >
        <Box w={['100%', '50%', '50%', '50%']} float="right" pl="1.5rem">
          <HStack mb="2rem" gap={['4', '2', '2', '2']}>
            <Button
              href="#services"
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontFamily="Work Sans"
              fontSize={['.6rem', '1rem', '.7rem', '1rem']}
              color="#fff"
              bg="#1F1F29"
              p={['.75rem 3rem', '1rem 1rem']}
              borderRadius="16px"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Biometric Payment
            </Button>
            <Button
              display={['flex', 'flex', 'flex', 'flex']}
              href="#services"
              fontFamily="Work Sans"
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontSize={['.6rem', '.7rem', '.7rem', '1rem']}
              color="#A0A4A8"
              cursor="pointer"
              bg="#fff"
              p=".15rem 1rem"
              borderRadius="16px"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Payment Code
            </Button>
          </HStack>
          <Text
            fontSize={['1.25rem', '1.5rem', '1.5rem', '2rem']}
            color="#1F1F29"
            mt="1rem"
            fontFamily="Duplicate Sans"
            fontWeight="500"
          >
            Online Payment, Simplified
          </Text>
          <Text
            fontSize={['.75rem', '1rem']}
            lineHeight="28px"
            mt="1rem"
            fontFamily="Work Sans"
            color="#445368"
          >
            Don’t just get paid, withdraw your funds easily from your account
            with just your biometric
          </Text>
          <HStack mt="1rem" gap={['4', '2', '2', '2']}>
            <Link
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontSize={['.7rem', '1rem', '.7rem', '1rem']}
              color="#246BFD"
              bg="#fff"
              display="flex"
              alignItems="center"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              View usecase&nbsp;{' '}
              <Image
                src="/arrow.png"
                _hover={{ marginLeft: '.2rem' }}
                alt="socials"
              />
            </Link>
          </HStack>
        </Box>
        <Box display={['none','block']} w={['100%', '50%', '50%', '50%']}>
          <Image
            m="auto"
            w=""
            h="100%"
            src="/biometric payment illustration.svg"
            alt="mobile"
          />
        </Box>
        <Box display={['block','none']} w={['100%', '50%', '50%', '50%']}>
          <Image
            m="auto"
            w=""
            h="100%"
            src="/bpi.png"
            alt="mobile"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Payment;
